import { Box, Center, Spinner } from '@chakra-ui/react'
import TableColumnSettings from 'components/table/table-column-settings'
import React, { useEffect, useState } from 'react'
import { TableNames } from 'types/table-column.types'
import { useTableColumnSettings, useTableColumnSettingsUpdateMutation } from 'api/table-column-settings-refactored'
import { useDocuments } from 'api/vendor-projects'
import { DOCUMENTS_TABLE_COLUMNS } from 'constants/documents.constants'
import { TableContextProvider } from 'components/table-refactored/table-context'
import { ButtonsWrapper, CustomDivider, TableFooter } from 'components/table-refactored/table-footer'
import { Table } from 'components/table-refactored/table'
import { ExportCustomButton } from 'components/table-refactored/export-button'
import {
  GotoFirstPage,
  GotoLastPage,
  GotoNextPage,
  GotoPreviousPage,
  ShowCurrentRecordsWithTotalRecords,
  TablePagination,
} from 'components/table-refactored/pagination'
import { useUserRolesSelector } from 'utils/redux-common-selectors'

export const VendorDocumentsTable = React.forwardRef((props: any, ref) => {
  const projectId = props?.projectId as string
  const { documents, isLoading: isLoadingDocuments } = useDocuments(projectId as string)
  const [totalPages, setTotalPages] = useState(0)
  const [totalRows, setTotalRows] = useState(0)

  const { mutate: postDocumentColumn } = useTableColumnSettingsUpdateMutation(TableNames.document)
  const {
    tableColumns,
    settingColumns,
    isLoading,
    refetch: refetchColumns,
  } = useTableColumnSettings(DOCUMENTS_TABLE_COLUMNS, TableNames.document)

  const onSave = columns => {
    postDocumentColumn(columns)
  }

  useEffect(() => {
    if (!documents?.length) {
      setTotalPages(1)
      setTotalRows(0)
    } else {
      setTotalPages(Math.ceil((documents?.length ?? 0) / 50))
      setTotalRows(documents?.length ?? 0)
    }
  }, [documents])

  const setPageCount = rows => {
    if (!rows?.length) {
      setTotalPages(1)
      setTotalRows(0)
    } else {
      setTotalPages(Math.ceil((rows?.length ?? 0) / 50))
      setTotalRows(rows?.length ?? 0)
    }
  }

  const onRowClick = row => {}
  const { isVendor } = useUserRolesSelector()
  const tableH = props?.isReceivable ? '420px' : isVendor ? '100vh' : '100vh'
  return (
    <>
      {isLoadingDocuments && (
        <Center minH="calc(100vh - 450px)">
          <Spinner size="lg" />
        </Center>
      )}
      {documents && (
        <Box
          overflowY={'auto'}
          w="100%"
          minH={tableH}
          {...(props?.isReceivable && { maxH: '490px' })}
          position="relative"
          borderRadius="6px"
          border="1px solid #CBD5E0"
          overflowX="auto"
          roundedRight={{ base: '0px', sm: '6px' }}
          sx={{
            '&::-webkit-scrollbar': {
              width: '10px',
              height: '10px',
            },
            '&::-webkit-scrollbar-track': {
              background: '#f1f1f1',
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: '#C2C7CD',
              borderRadius: '1px',
              border: '2px solid #f1f1f1',
            },
            scrollbarWidth: 'thin',
          }}
        >
          <TableContextProvider
            totalPages={totalPages}
            manualPagination={false}
            data={documents}
            columns={tableColumns}
            isExpandable={true}
          >
            <Table onRowClick={onRowClick} isLoading={isLoading} isEmpty={!isLoading && !documents?.length} />
            <TableFooter position="sticky" bottom="0" left="0" right="0">
              <ButtonsWrapper>
                <ExportCustomButton columns={tableColumns} data={documents} fileName="documents" />
                <CustomDivider />
                {settingColumns && (
                  <TableColumnSettings
                    refetch={refetchColumns}
                    disabled={isLoading}
                    onSave={onSave}
                    columns={settingColumns}
                  />
                )}
              </ButtonsWrapper>
              <TablePagination>
                <ShowCurrentRecordsWithTotalRecords dataCount={totalRows} setPageCount={setPageCount} />
                <GotoFirstPage />
                <GotoPreviousPage />
                <GotoNextPage />
                <GotoLastPage />
              </TablePagination>
            </TableFooter>
          </TableContextProvider>
        </Box>
      )}
    </>
  )
})
